import request from "@/utils/request";

let UserAssetApi = {
  /*列表*/
  getUserAsset(data) {
    return request._post("shop/user_asset.synchronous.Syn/index", data);
  },
  deleteUserAsset(data) {
    return request._post("shop/user_asset.synchronous.Syn/delete", data);
  },
  /* 获取管理信息 */
  getManager(data) {
    return request._post("/shop/plus.plugins.Index/_call", data);
  },
  /* 获取编辑*/
  getEdit(data) {
    return request._post("/shop/plus.plugins.Index/get_goods", data);
  },
  /* 保存 */
  saveUserAsset(data) {
    return request._post("/shop/plus.plugins.Index/edit_shop", data);
  },
  /* 彻底删除 */
  dellUserAsset(data) {
    return request._post("/shop/user_asset.synchronous.Syn/dell_syn", data);
  },
  /* 恢复 */
  recycleUserAsset(data) {
    return request._post("/shop/user_asset.synchronous.Syn/recovery_api", data);
  },
  /* 获取添加资产表单 */
  getAddFormItems(data) {
    return request._post("/shop/plus.plugins.Index/get_shop", data);
  },
  /* 获取所有用户 */
  getUserList(data) {
    return request._post("/shop/user.user/index", data);
  },
  addUserAsset(data) {
    return request._post("/shop/plus.plugins.Index/add_shop", data);
  },
  /* 批量添加Api */
  batchUserAsset(data) {
    return request._post("/shop/plus.plugins.Index/add_shops", data);
  },
};
export default UserAssetApi;



// WEBPACK FOOTER //
// ./src/api/userasset.js